import type { BaseColor } from './types';

/**
 * 'multi' has no single hex: the UI renders a multicolor swatch.
 */
export const BASE_COLORS = [
  { key: 'black', label: 'Black', hex: '#000000' },
  { key: 'white', label: 'White', hex: '#FFFFFF' },
  { key: 'grey', label: 'Grey', hex: '#808080' },
  { key: 'brown', label: 'Brown', hex: '#8B4513' },
  { key: 'beige', label: 'Beige', hex: '#F5F5DC' },
  { key: 'red', label: 'Red', hex: '#E11900' },
  { key: 'orange', label: 'Orange', hex: '#FF7A00' },
  { key: 'yellow', label: 'Yellow', hex: '#F5C000' },
  { key: 'green', label: 'Green', hex: '#0E8A00' },
  { key: 'blue', label: 'Blue', hex: '#1A56DB' },
  { key: 'purple', label: 'Purple', hex: '#7C3AED' },
  { key: 'pink', label: 'Pink', hex: '#EC4899' },
  { key: 'gold', label: 'Gold', hex: '#D4AF37' },
  { key: 'silver', label: 'Silver', hex: '#C0C0C0' },
  { key: 'multi', label: 'Multi', hex: '' },
] as const satisfies readonly BaseColor[];

const BASE_COLOR_KEYS = new Set(BASE_COLORS.map((color) => color.key));

export function isBaseColor(key: string): boolean {
  return BASE_COLOR_KEYS.has(key as (typeof BASE_COLORS)[number]['key']);
}

/**
 * A key or a label, case- and whitespace-insensitive; null when it matches
 * nothing.
 */
export function resolveBaseColor(input: string): string | null {
  const needle = input.trim().toLowerCase();
  const match = BASE_COLORS.find(
    (color) => color.key === needle || color.label.toLowerCase() === needle,
  );
  return match?.key ?? null;
}
